import {BenjiKIV} from "../BenjiKIV";
import {SimpleReelModelState} from "../../core/reel/ReelInterfaces";
import {SimpleReelModelEventData} from "./BenjiKIVReelModel";
import {BenjiKIVStackedSymbol} from "./BenjiKIVStackedSymbol";
import {BenjiKIVStatics} from "../BenjiKIVStatics";

/**
 * Created by Jerker Nord on 2023-01-20.
 */

export class BenjiKIVMidSymController {

    private _fullStackedLanded:string[];
    private _bounceReels:boolean[];
    private _isAborted:boolean = false;
    private _abortedSoundPlayed:boolean = false;

    constructor() {
        this.addReelStopListeners();
    }

    private addReelStopListeners():void {
        for(let i:number = 0; i < 5; i++) {
            BenjiKIV.allReelView.reelModels[i].events?.on(SimpleReelModelState.SPIN, (data:SimpleReelModelEventData) => this.onReelStarted(data));
            BenjiKIV.allReelView.reelModels[i].events?.on(SimpleReelModelState.BOUNCE, (data:SimpleReelModelEventData) => this.onReelStopBounce(data));
        }
    }

    private onReelStarted(data:SimpleReelModelEventData) {
        this._isAborted = false;
        this._abortedSoundPlayed = false;
        this._fullStackedLanded = [];
        this._bounceReels = [false, false, false, false, false];
    }

    private playRandomDeadPresidentSound():void{
        if (BenjiKIVStatics.isSpinAborted == false){
            BenjiKIV.soundPlayer.playRandomDeadPresident();
        }else if (this._abortedSoundPlayed == false){
            this._abortedSoundPlayed = true;
            BenjiKIV.soundPlayer.playRandomDeadPresident();
        }
    }

    //NOTE! On quickstop the reel can stop in random order
    private onReelStopBounce(data:SimpleReelModelEventData) {
        this._bounceReels[data.reel] = true;

        //If fullstacked land on first 3 reels, look on all reels landed for nudging mids OR fullstacked mids landed on reel 4 and 5 to turn dead.
        if(data.reel < 3) {
            if(BenjiKIV.model.midsLandedFull[data.reel] == true) {
                const midSym:BenjiKIVStackedSymbol = BenjiKIV.stackedSymbolsPool.getMidSymbolOnReel(data.reel);
                midSym.isDead = true;
                this._fullStackedLanded.push(midSym.symbolName);
                this.playRandomDeadPresidentSound();
                midSym.getActivateDeadOverlayTL();
                //Full stacked has landed. Check all stopped reels for nudge of same symbol OR full stacked on last 2 reels and turn them dead
                for(let i:number = 0; i < this._bounceReels.length; i++) {
                    if(this._bounceReels[i] == true && (BenjiKIV.model.mNudgeReels[i] !== 0 || ((i > 2) && (BenjiKIV.model.midsLandedFull[i] == true)))) {
                        const goDeadSym:BenjiKIVStackedSymbol = BenjiKIV.stackedSymbolsPool.getMidSymbolOnReel(i);
                        if (goDeadSym.isDead == false && goDeadSym.symbolName == midSym.symbolName){
                            goDeadSym.isDead = true;
                            goDeadSym.getActivateDeadOverlayTL();
                        }
                    }
                }
            }
        }

        //If full stacked lands on last two reels, check if stacked of same type has landed
        if ((data.reel > 2) && BenjiKIV.model.midsLandedFull[data.reel] == true){
            const goDeadSym:BenjiKIVStackedSymbol = BenjiKIV.stackedSymbolsPool.getMidSymbolOnReel(data.reel);
            if (goDeadSym.isDead == false && this._fullStackedLanded.includes(goDeadSym.symbolName) == true){
                goDeadSym.isDead = true;
                this.playRandomDeadPresidentSound();
                goDeadSym.getActivateDeadOverlayTL();
            }
        }

        //If nudge lands, check if stacked of same type has landed
        if (BenjiKIV.model.mNudgeReels[data.reel] !== 0){
            const nudgeSym:BenjiKIVStackedSymbol = BenjiKIV.stackedSymbolsPool.getMidSymbolOnReel(data.reel);
            if (nudgeSym.isDead == false && this._fullStackedLanded.includes(nudgeSym.symbolName) == true){
                nudgeSym.isDead = true;
                this.playRandomDeadPresidentSound();
                nudgeSym.getActivateDeadOverlayTL();
            }
        }
    }

    set isAborted(value:boolean) {
        this._isAborted = value;
    }
}